import { Navbar } from "@/components/site/Navbar";
import { Hero } from "@/components/site/Hero";
import { About } from "@/components/site/About";
import { Highlights } from "@/components/site/Highlights";
import { Units } from "@/components/site/Units";
import { FloorPlans } from "@/components/site/FloorPlans";
import { Location } from "@/components/site/Location";
import { Ecorb } from "@/components/site/Ecorb";
import { Contact } from "@/components/site/Contact";
import { Footer } from "@/components/site/Footer";
import { MobileCallCTA } from "@/components/site/MobileCallCTA";

const Home = () => {
  return (
    <main className="bg-[#050505] text-[#F8F6F0] min-h-screen" data-testid="home-page">
      <Navbar />
      <Hero />
      <About />
      <Highlights />
      <Units />
      <FloorPlans />
      <Location />
      <Ecorb />
      <Contact />
      <Footer />
      <MobileCallCTA />
    </main>
  );
};

export default Home;
